(function($) {
    $(() => {
        $.getUrlParameter = function getUrlParameter(sParam) {
            var sPageURL = decodeURIComponent(window.location.search.substring(1)),
                sURLVariables = sPageURL.split('&'),
                sParameterName,
                i;

            for (i = 0; i < sURLVariables.length; i++) {
                sParameterName = sURLVariables[i].split('=');

                if (sParameterName[0] === sParam) {
                    return sParameterName[1] === undefined ? true : sParameterName[1];
                }
            }
        };

        function replaceUrlParam(url, paramName, paramValue) {
            if (paramValue == null) {
                paramValue = '';
            }
            var pattern = new RegExp('\\b(' + paramName + '=).*?(&|#|$)');
            if (url.search(pattern) >= 0) {
                return url.replace(pattern, '$1' + paramValue + '$2');
            }
            url = url.replace(/[?#]$/, '');
            return url + (url.indexOf('?') > 0 ? '&' : '?') + paramName + '=' + paramValue;
        }

        const searchClient = algoliasearch(algolia_localize.app_id, algolia_localize.search_key);
        let sections = algolia_localize.page_settings.section;
        let global_index_name = algolia_localize.page_settings.index_name;

        let search;

        const monthNames = [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sept',
            'Oct',
            'Nov',
            'Dec'
        ];

        function getDate(date) {
            if (date == undefined) {
                var date = new Date();
            }
            return (
                (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) +
                ' ' +
                monthNames[date.getMonth()] +
                ', ' +
                date.getFullYear()
            );
        }

        function template(item, type, index) {
            let template;
            
            var featured_image =
                item['featured_image'] ||
                algolia_localize.plugin_url + 'assets/img/placeholder_pic.png';

            if (type == 'blogs') {
                const date = getDate(new Date(item['date']));
                template = `<div class="col-lg-3 col-md-4 col-12">
                    <div class="tile tile--border p-relative match-h">
                        <a class="p-absolute-0" href="${item['url']}"></a>
                    
                        <div class="tile__bg" style="background-image: url('${featured_image}')">
                        </div>
                        <div class="tile__content">
                            <div class="tile__content__categories">
                                ${item['blogs_category']?.map(
                                    category => `
                                <span  class="category">
                                    ${category.name}
                                </span>
                                `
                                )}
                            </div>
                            <div class="tile__content__logo">
                            <img src="${
                                algolia_localize.plugin_url
                            }/assets/img/mini_logo_grey.svg" alt="logo">
                                <p>
                                    by ${item['author']} / ${date}
                                </p>
                            </div>
                            <div class="tile__content__wrapper">
                                <h5 class="tile__content__wrapper__title">
                                ${instantsearch.highlight({ attribute: 'title', hit: item })}
                                </h5>
                                
                            </div>
                        </div>
                        <img class="tile__arrow" src="${
                            algolia_localize.plugin_url
                        }/assets/img/tile_arrow.svg" alt="tile_arrow">
                    </div>
                </div>`;
            }

            if (type == 'knowledge-base') {
                const date = getDate(new Date(item['date']));
                template = `<div class="col-lg-3 col-md-4 col-12">
                    <div class="tile tile--border p-relative match-h">
                        <a class="p-absolute-0" href="${item['url']}"></a>
                    
                        <div class="tile__bg" style="background-image: url('${featured_image}')">
                        </div>
                        <div class="tile__content">
                            <div class="tile__content__categories">
                                ${item['knowledge_base_category']?.map(
                                    category => `
                                <span  class="category" style="background-color: #e41b20;">
                                    ${category.name}
                                </span>
                                `
                                )}
                            </div>
                            <div class="tile__content__logo">
                            <img src="${
                                algolia_localize.plugin_url
                            }/assets/img/simsports.svg" alt="logo">
                                <p>
                                    ${date}
                                </p>
                            </div>
                            <div class="tile__content__wrapper">
                                <h5 class="tile__content__wrapper__title">
                                ${instantsearch.highlight({ attribute: 'title', hit: item })}
                                </h5>
                                
                            </div>
                        </div>
                        <img class="tile__arrow" src="${
                            algolia_localize.plugin_url
                        }/assets/img/tile_arrow.svg" alt="tile_arrow">
                    </div>
                </div>`;
            }

            if (type == "product") {
        
                template = `<div class="col-lg-3 col-md-4 col-12">
                <div class="tile-product match-h">
                    <a class="p-absolute-0" href="${item["url"]}"></a>
                    <div class="tile-product__bg" style="background-image: url('${featured_image}')">
                    </div>
                    <div class="tile-product__content">
                      <div class="tile__content__categories">
                        ${item["product_cat"]?.map(category => `
                          <span  class="category" style="background-color: #e41b20;">
                            ${category.name}
                          </span>
                        `)}
                      </div>
                        <h5>
                        ${instantsearch.highlight({ attribute: "title", hit: item })}
                        </h5>
                    </div>
                </div>
            </div>`;
              }

            if (type == 'oem_partner_products') {
                template = `<div class="col-lg-3">
                        <div class="tile-product match-h">
                            <a class="p-absolute-0" href="${item['url']}"></a>
                            <div class="tile-product__bg" style="background-image: url('${featured_image}')">
                            </div>
                            <div class="tile-product__content">
                                ${item['products_category']?.map(
                                    category => `
                                <span  class="category">
                                    ${category.name}
                                </span>
                                `
                                )}
                                <div class="tile-product__content__logo">
                                
                                ${
                                    item['partner']
                                        ? `${item['partner']?.map(
                                                partner => `
                                    ${
                                        partner.post_title === 'Asetek'
                                            ? `<img src="${algolia_localize.plugin_url}/assets/img/mini_logo.svg" alt="logo">`
                                            : ``
                                    }
                                    <p>
                                        ${partner.post_title}
                                    </p>
                                    `
                                            )}`
                                        : ``
                                }

                                </div>
                                <h5>
                                ${instantsearch.highlight({ attribute: 'title', hit: item })}
                                </h5>
                            </div>
                        </div>
                    </div>`;
            }

            if (type == 'press-releases') {
                const date = getDate(new Date(item['date']));
                template = `<div class="col-lg-3 col-md-4 col-12">
        <div class="tile tile--border p-relative match-h">
            <a class="p-absolute-0" href="${item['url']}"></a>
           
            <div class="tile__bg" style="background-image: url('${featured_image}')">
            </div>
            <div class="tile__content">
                <div class="tile__content__categories">
                  ${item['topic_category']?.map(
                      category => `
                    <span  class="category">
                      ${category.name}
                    </span>
                  `
                  )}
                </div>
                <div class="tile__content__logo">
                  <img src="${
                      algolia_localize.plugin_url
                  }/assets/img/mini_logo_grey.svg" alt="logo">
                    <p>
                    ${date}
                    </p>
                </div>
                <div class="tile__content__wrapper">
                    <h5 class="tile__content__wrapper__title">
                      ${instantsearch.highlight({ attribute: 'title', hit: item })}
                    </h5>
                    
                </div>
            </div>
            <img class="tile__arrow" src="${
                algolia_localize.plugin_url
            }/assets/img/tile_arrow.svg" alt="tile_arrow">
        </div>
    </div>`;
            }

            if (type == 'videos') {
                const date = getDate(new Date(item['date']));
                template = `<div class="col-lg-3 col-md-4 col-12">
        <div class="tile tile--border p-relative match-h">
            <a class="p-absolute-0" href="${item['url']}"></a>
           
            <div class="tile__bg" style="background-image: url('${featured_image}')">
            </div>
            <div class="tile__content">
                <div class="tile__content__categories">
                  ${item['topic_category']?.map(
                      category => `
                      <span  class="category">
                        ${category.name}
                      </span>
                  `
                  )}
                </div>
                <div class="tile__content__logo">
                  <img src="${
                      algolia_localize.plugin_url
                  }/assets/img/mini_logo_grey.svg" alt="logo">
                  <p>
                    ${date}
                  </p>
                </div>
                <div class="tile__content__wrapper">
                    <h5 class="tile__content__wrapper__title">
                      ${instantsearch.highlight({ attribute: 'title', hit: item })}
                    </h5>
                    
                </div>
            </div>
            <img class="tile__arrow" src="${
                algolia_localize.plugin_url
            }/assets/img/tile_arrow.svg" alt="tile_arrow">
        </div>
    </div>`;
            }

            if (type == 'partners') {
                template = `
          <div class="col-lg-3">
              <div class="tile-partner">
                  <a class="p-absolute-0" href="${item['url']}"></a>
                  <div class="tile-partner__bg" style="background-image: url('${featured_image}')">
                  </div>
                  <h5 class="text-center">
                    ${instantsearch.highlight({ attribute: 'title', hit: item })}
                  </h5>
              </div>
          </div>
        `;
            }

            if (type == 'members') {
                template = `
          <div class="col-lg-3">
            <div class="tile-member match-h">
                <a class="p-absolute-0" href="${item['url']}"></a>
                <div class="tile-member__bg" style="background-image: url('${featured_image}')">
                
                </div>
                <div class="tile-member__content">
                    ${item['members_category']?.map(
                        category => `
                      <span  class="category">
                        ${category.name}
                      </span>
                    `
                    )}
                    <h5 class="tile-member__content__title">
                      ${instantsearch.highlight({ attribute: 'title', hit: item })}
                    </h5>
                    
                </div>
            </div>
        </div>
        `;
            }

            if (type == 'page') {
                template = `
          <div class="col-lg-4">
            <div>
              <a href="${item['url']}">
                <p class="page-title">
                  ${instantsearch.highlight({ attribute: 'title', hit: item })}
                </p>
              </a>
            </div>
          </div>`;
            }

            return template;
        }

        const renderStats = (renderOptions, isFirstRender) => {
            const { nbHits, areHitsSorted, nbSortedHits, widgetParams } = renderOptions;

            if ($('.template__algolia_search').length) {
                if (isFirstRender) {
                    return;
                }

                let count = '';

                if (areHitsSorted) {
                    if (nbSortedHits > 1) {
                        count = `${nbSortedHits} relevant results`;
                    } else if (nbSortedHits === 1) {
                        count = '1 relevant result';
                    } else {
                        count = 'No relevant result';
                    }
                    count += ` sorted out of ${nbHits}`;
                } else {
                    if (nbHits > 1) {
                        count += `${nbHits} ${algolia_localize.translations.algolia_results_text_overwrite}`;
                    } else if (nbHits === 1) {
                        count += `1 ${algolia_localize.translations.algolia_result_text_overwrite}`;
                    } else {
                        count += 'no result';
                    }
                }
                widgetParams.container.innerHTML = `${count}`;
            }
        };

        const renderPagination = (renderOptions, isFirstRender) => {
            const {
                pages,
                currentRefinement,
                nbPages,
                isFirstPage,
                isLastPage,
                refine,
                createURL,
                widgetParams
            } = renderOptions;

            if ($('.template__algolia_search').length) {
                widgetParams.container.innerHTML = `
     
        <ul class="pagination">
            <li class="pagination__arrow-wrapper">
              <a class="control  control--left ${
                  isFirstPage ? ' control--disabled' : ''
              }"  href="${createURL(currentRefinement - 1)}" data-value="${currentRefinement - 1}">
                <svg class="control__icon" width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M6.06967 11.1387C6.38209 10.8263 6.38209 10.3198 6.06967 10.0074L2.10987 6.04756L6.16412 1.9933C6.47654 1.68088 6.47654 1.17435 6.16412 0.861931C5.8517 0.549512 5.34517 0.549511 5.03275 0.86193L0.507269 5.38741C0.491352 5.40333 0.47625 5.41975 0.461955 5.43662C0.445107 5.4509 0.428711 5.46598 0.412818 5.48188C0.100398 5.7943 0.100398 6.30083 0.412817 6.61325L4.9383 11.1387C5.25072 11.4512 5.75725 11.4512 6.06967 11.1387Z" fill="#222140"/>
                </svg>
              </a>
            </li>
  
            <li>
              <a
                href="${createURL(0)}"
                data-value="${0}"
                
                class="page-numbers ${currentRefinement === 0 ? 'current' : ''}"
              >
              1
              </a>
            </li>
            ${
                currentRefinement > 1 && currentRefinement + 1 !== nbPages
                    ? `<li> <span class="page-numbers page-numbers--dots"> ... </span> </li>`
                    : ``
            }
        ${pages
            .map(
                (page, index) => `
         
          ${
              page === 0 || index === pages.length - 1
                  ? ''
                  : `
             
             ${
                 currentRefinement === page
                     ? `<li>
               <a
                 href="${createURL(page)}"
                 data-value="${page}"
                 
                 class="page-numbers ${currentRefinement === page ? 'current' : ''}"
               >
                 ${page + 1}
               </a>
             </li>`
                     : ``
             }
             
           ${
               index + 1 === pages.length - 1 && currentRefinement + 2 !== nbPages
                   ? `<li> <span class="page-numbers page-numbers--dots"> ... </span> </li>`
                   : ``
           }
           
           `
          }
            
          `
            )
            .join('')}
        ${
            nbPages !== 1
                ? `<li>
            <a
              href="${createURL(nbPages - 1)}"
              data-value="${nbPages - 1}"
              
              class="page-numbers ${currentRefinement === nbPages - 1 ? 'current' : ''}"
            >
              ${nbPages}
            </a>
          </li>`
                : ``
        }
  
        <li class="pagination__arrow-wrapper">
            <a class="control control--right ${
                isLastPage ? ' control--disabled' : ''
            }"  href="${createURL(currentRefinement + 1)}" data-value="${currentRefinement + 1}">
              <svg class="control__icon" width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M0.930327 0.861268C0.617908 1.17369 0.617907 1.68022 0.930327 1.99264L4.89013 5.95244L0.835875 10.0067C0.523456 10.3191 0.523456 10.8256 0.835875 11.1381C1.14829 11.4505 1.65483 11.4505 1.96725 11.1381L6.49273 6.61259C6.50865 6.59667 6.52375 6.58025 6.53804 6.56338C6.55489 6.5491 6.57129 6.53402 6.58718 6.51812C6.8996 6.2057 6.8996 5.69917 6.58718 5.38675L2.0617 0.861268C1.74928 0.548848 1.24275 0.548849 0.930327 0.861268Z" fill="#222140"/>
              </svg>
            </a>
          </li>
      </ul>
      
        `;

                [...widgetParams.container.querySelectorAll('a')].forEach(element => {
                    element.addEventListener('click', event => {
                        event.preventDefault();
                        refine(event.currentTarget.dataset.value);
                    });
                });
            }
        };

        // Create the render function
        const renderHits = (renderOptions, isFirstRender) => {
            const { hits, widgetParams } = renderOptions;

            if (hits.length > 0) {
                $(`#${widgetParams.container.id}`)
                    .parent()
                    .removeClass('no--result');
                widgetParams.container.innerHTML = `
      ${hits.map(item => template(item, widgetParams.type, widgetParams.index)).join('')}
    `;
            } else {
                $(`#${widgetParams.container.id}`)
                    .parent()
                    .addClass('no--result');
                widgetParams.container.innerHTML = `<div class="col-md-12"><p class="no__results">${algolia_localize.translations.algolia_no_result_text_overwrite}</p></div>`;
            }

            $.fn.matchHeight._applyDataApi();
            $('.match-h').matchHeight({
                byRow: true,
                property: 'height',
                target: null,
                remove: false
            });
        };

        function searchSetup() {
            $(sections).each(function(i, e) {
                var currentFacetFilters = [];
                currentFacetFilters.push([`type:${e.type}`]);

                if (e.sources.length > 0) {
                    currentFacetFilters.push(e.sources);
                }

                // if (algolia_localize.page_settings.render_custom_hits) {
                const customHits = instantsearch.connectors.connectHits(renderHits);

                // }

                const customStats = instantsearch.connectors.connectStats(renderStats);
                const customPagination = instantsearch.connectors.connectPagination(
                    renderPagination
                );

                var currentHitsPerPage = e.number_of_hits_per_page_default;
                if (hasTab != '' && hasTab != undefined) {
                    currentHitsPerPage = e.number_of_hits_per_page_filtered_state;
                    if (hasTab != e.title) {
                        $(`#${e.title}.js-section-result`).addClass('hidden');
                    }
                }

                if (i == 0) {
                    search = instantsearch({
                        indexName: global_index_name,
                        searchClient,
                        // routing: true,
                        routing: {
                            router: instantsearch.routers.history({
                                createURL({ qsModule, location, routeState }) {
                                    const { origin, pathname, hash } = location;
                                    const queryString = qsModule.stringify(routeState);

                                    var currentTab = $.getUrlParameter('tab');
                                    var hasTab = false;

                                    if (currentTab != '' && currentTab != undefined) {
                                        hasTab = true;
                                    }

                                    if (hasTab) {
                                        if (queryString) {
                                            return `${origin}${pathname}?tab=${currentTab}&${queryString}`;
                                        } else {
                                            return `${origin}${pathname}?tab=${currentTab}`;
                                        }
                                    } else {
                                        if (queryString) {
                                            return `${origin}${pathname}?${queryString}`;
                                        } else {
                                            return `${origin}${pathname}`;
                                        }
                                    }
                                },
                                stateMapping: instantsearch.stateMappings.simple()
                            })
                        },
                        searchFunction(helper) {
                            if (helper.state.query == '') {
                                helper.setQueryParameter('filters', 'show_default:true');
                                helper.search();
                            } else {
                                helper.setQueryParameter(
                                    'filters',
                                    'show_default:true OR show_default:false'
                                );
                                helper.search();
                            }
                        }
                    });

                    search.on('render', () => {
                        $('.js-section-result').animate({ opacity: 1 });
                    });

                    const catArray = {
                        search_partners: 'Partners',
                        search_page: 'Pages',
                        search_blogs: 'Blogs',
                        'search_press-releases': 'Press Releases',
                        search_videos: 'Videos',
                        search_product : 'SimSports Products',
                        'search_knowledge-base' : 'Knowledge base'
                    };

                    const imageArray = {
                        blogs: {
                            '': ''
                        },
                        'press-releases': ''
                    };

                    const typesArray = ['blogs', 'press-releases', 'videos'];

                    // Helper for the render function

                    if (algolia_localize.page_settings.searchbox) {
                        const renderIndexListItem = function({ indexId, hits }) {
                            let logo = 'company';
                            if (indexId === 'search_blogs') {
                                logo = 'liquid_cooling';
                            }

                            if(indexId === 'search_product') {
                                logo = 'simsports';
                              }

                            return `
    
    
                  ${
                      indexId === 'asetek' || indexId === 'asetek-live'
                          ? ''
                          : ` ${
                                hits.length != 0
                                    ? `<p class="cat-p"> ${catArray[indexId]} </p>`
                                    : ``
                            }
                    ${hits
                        .map(function(hit, hitIndex) {
                            if (typesArray.includes(hit.type)) {
                                if (hit.type === 'blogs') {
                                    hit.blogs_category.map(function(category) {
                                        if (category.slug === 'liquid-cooling') {
                                            logo = 'liquid_cooling';
                                        }

                                        if (
                                            category.slug === 'company-blog' ||
                                            category.slug === 'company'
                                        ) {
                                            logo = 'company';
                                        }

                                        if (category.slug === 'simsports') {
                                            logo = 'simsports';
                                        }
                                    });
                                } else {
                                    hit.topic_category.map(function(category) {
                                        if (category.slug === 'simsports') {
                                            logo = 'simsports';
                                        }
                                    });
                                }
                            }

                            return `
                            <li>
                              <img class="algolia-hit-logo" src="${
                                  algolia_localize.plugin_url
                              }/assets/img/${logo}.svg" alt="logo">
                              <a href="${
                                  hit.url
                              }">${instantsearch.highlight({ attribute: 'title', hit })}</a>
                            </li>
                          `;
                        })
                        .join('')}
                  `
                  }
            `;
                        };

                        // Create the render function

                        const renderAutocomplete = (renderOptions, isFirstRender) => {
                            const {
                                indices,
                                currentRefinement,
                                refine,
                                widgetParams
                            } = renderOptions;

                            if (isFirstRender) {
                                const input = document.createElement('input');
                                const ul = document.createElement('ul');

                                input.classList.add('own-input');
                                input.classList.add('js-own-input');

                                ul.classList.add('own-ul');

                                input.addEventListener('input', event => {
                                    refine(event.currentTarget.value);
                                });

                                widgetParams.container.appendChild(input);
                                widgetParams.container.appendChild(ul);
                            }

                            widgetParams.container.querySelector('input').value = currentRefinement;

                            widgetParams.container.querySelector('ul').innerHTML = indices
                                .map(renderIndexListItem)
                                .join('');
                        };

                        // Create the custom widget
                        const customAutocomplete = instantsearch.connectors.connectAutocomplete(
                            renderAutocomplete
                        );

                        // Instantiate the custom widget
                        search.addWidgets([
                            customAutocomplete({
                                container: document.querySelector('#autocomplete')
                            })
                        ]);
                    }
                }

                $(document).ready(function() {
                    $('.js-own-input').attr(
                        'placeholder',
                        algolia_localize.translations.algolia_searchbox_text_placeholder_overwrite
                    );
                    $('.js-own-input').on('focusin', function() {
                        $(this)
                            .next()
                            .addClass('show');
                    });

                    $('.js-own-input').on('focusout', function(e) {
                        setTimeout(function() {
                            $(this)
                                .next()
                                .removeClass('show');
                        }, 300);
                    });
                });

                if (algolia_localize.page_settings.render_custom_hits) {
                    search.addWidgets([
                        instantsearch.widgets
                            .index({
                                indexName: global_index_name,
                                indexId: 'search_' + e.type
                            })
                            .addWidgets([
                                customStats({
                                    container: document.querySelector(`#section_${i}_stats`),
                                    index: i
                                }),
                                customHits({
                                    container: document.querySelector(`#section_${i}_hits`),
                                    type: e.type,
                                    index: i
                                }),
                                customPagination({
                                    container: document.querySelector(`#section_${i}_pagination`)
                                }),
                                instantsearch.widgets.configure({
                                    hitsPerPage: currentHitsPerPage,
                                    facetFilters: currentFacetFilters
                                })
                            ])
                    ]);
                } else {
                    search.addWidgets([
                        instantsearch.widgets
                            .index({
                                indexName: global_index_name,
                                indexId: 'search_' + e.type
                            })
                            .addWidgets([
                                instantsearch.widgets.configure({
                                    hitsPerPage: currentHitsPerPage,
                                    facetFilters: currentFacetFilters
                                })
                            ])
                    ]);
                }
            });
        }

        var hasTab = $.getUrlParameter('tab');

        if (hasTab != '' && hasTab != undefined) {
            $(`.js-category-item[data-tab="${hasTab}"]`).addClass('active');
        } else {
            $('.js-category-item[data-tab=""]').addClass('active');
        }

        if (algolia_localize.page_settings.render_custom_hits) {
            searchSetup();
            search.start();
        } else {
            $('.js-search-modal').on('click', function() {
                if (!$(this).hasClass('started')) {
                    
                    $('.js-search-modal').each(function(index){
                        $(this).addClass('started');
                    });

                    searchSetup();
                    search.start();
                }
            });
        }

        $('.js-category-item').on('click', function(e) {
            e.preventDefault();
            var tab = $(this).data('tab');

            var url = window.location.href.split('?')[0];
            if (tab != '') {
                url = replaceUrlParam(url, 'tab', tab);
            }

            var currentQuery = $.getUrlParameter(`${global_index_name}[query]`);
            if (currentQuery != '' && currentQuery != undefined) {
                url = replaceUrlParam(url, `${global_index_name}[query]`, currentQuery);
            }
            window.location.href = encodeURI(url);
        });

        /*History go back if same domain*/
        $('.js-algolia-history-go-back').on('click', function(e) {
            e.preventDefault();
            var currentUrl = window.location.href;
            var $goto = $(this).data('goto');
            if (document.referrer.indexOf(algolia_localize.siteurl) >= 0) {
                history.go(-1);
                setTimeout(function() {
                    // if location was not changed in 100 ms, then there is no history back
                    if (currentUrl === window.location.href) {
                        window.location.href = $goto;
                    }
                }, 100);
            } else {
                window.location.href = $goto;
            }
        });

        // modal input enter event
        if ($('.algolia-autocomplete-modal-input-wrapper').length) {
            $('.algolia-autocomplete-modal-input-wrapper input').keyup(function(e) {
                if (e.keyCode == 13) {
                    window.location =
                        algolia_localize.siteurl +
                        '/search/?' +
                        window.location.search.substring(1);
                }
            });
        }

        $('.js-search-modal').on('click', function() {
            if (!$('.algolia-autocomplete-modal-input-wrapper').length) {
                $('html, body').animate(
                    {
                        scrollTop: $('#autocomplete_row').offset().top - 150
                    },
                    {
                        duration: 700
                    }
                );
            }

            $('#autocomplete input').focus();
        });

        $('.js-all-results').on('click', function(e) {
            e.preventDefault();

            if (window.location.search.length) {
                window.location =
                    algolia_localize.siteurl + '/search/?' + window.location.search.substring(1);
            } else {
                window.location = algolia_localize.siteurl + '/search/';
            }
        });
    });
})(jQuery);
